
export default () => {
    const siteHeaderEl = document.querySelector('.site-header');
    const headerNavEl = siteHeaderEl.querySelector('.site-header__nav');

    // Toggla menyn
    $('.site-header__nav-toggle').click(() => {
        document.body.classList.toggle('stop-scrolling');
        siteHeaderEl.classList.toggle('site-header--menu-open');

        const hidden = headerNavEl.getAttribute('aria-hidden');
        headerNavEl.setAttribute('aria-hidden', hidden === 'true' ? 'false' : 'true');
    });

    // Header dockning
    // const htmlEl = document.querySelector('html');
    // const headerDocker = () => {
    //     const scroll = htmlEl.scrollTop;

    //     if (scroll >= 250) {
    //         document.body.classList.add('scrolled');
    //     } else {
    //         document.body.classList.remove('scrolled');
    //     }
    // };
    // document.addEventListener('wheel', headerDocker, { capture: false, passive: true });

    // TODO: Ersätt med Lozad?
    // Ta bort data-src när bilden är laddad.
    // document.querySelectorAll('img[data-src]').forEach((el) => {
    //     const img = el;
    //     img.setAttribute('src', img.getAttribute('data-src'));
    //     img.onload = () => img.removeAttribute('data-src');
    // });


    $(document).ready(function () {

        AOS.init( {
            duration: 1000, // values from 0 to 3000, with step 50ms
            easing: 'ease-in-out',
            once: true,
        });
        //AOS.init({once: true});
       

        /* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
        var prevScrollpos = window.pageYOffset;
        window.onscroll = function() {
        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos > currentScrollPos) {
            $("#header").css("top","0");
        } else {
            var height= $("#header").height()+50;
            $("#header").css("top", "-"+height+"px");
        }
        prevScrollpos = currentScrollPos;
        }


        // smooth scroll for onepage links
        //https://css-tricks.com/snippets/jquery/smooth-scrolling/
        // Select all links with hashes
        $('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function (event) {
            // On-page links
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
            ) {
                // Figure out element to scroll to
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                var noScroll = false;

                if (target.length && !noScroll) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    // if menu open on mobile close when click
                    if($('#header').hasClass('site-header--menu-open')) {
                        document.body.classList.toggle('stop-scrolling');
                        siteHeaderEl.classList.toggle('site-header--menu-open');
                        const hidden = headerNavEl.getAttribute('aria-hidden');
                        headerNavEl.setAttribute('aria-hidden', hidden === 'true' ? 'false' : 'true');
                    }
                
                    $('html, body').animate({
                        scrollTop: target.offset().top /*- $('#header').height()*/ }, 1100, function () {
                        // Callback after animation
                        // Must change focus!
                        var target = $(target);
                        target.focus();
                        if (target.is(":focus")) { // Checking if the target was focused
                            return false;
                        } else {
                            target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                            target.focus(); // Set focus again
                        };
                    });
                }
            }
        });

        // check on page load 
        setActiveMenu();

        $(window).scroll(function() {
            setActiveMenu();
        });

        function setActiveMenu() {
            var current = "";
            $("section").each(function() {
                const sectionTop = $(this).offset();
                // added 5 for menuactivation
                if (((window.scrollY + $('.site-header').outerHeight(true)+5) >= sectionTop.top) && ((window.scrollY + $('.site-header').outerHeight(true)) <= (sectionTop.top + $(this).outerHeight(true)))) {
                    current = $(this).attr("id"); 
                    $("#main-nav ul li").each(function() {
                        $(this).removeClass("activemenu");
                        if ($(this).hasClass(current)) {
                            $(this).addClass("activemenu");
                        }
                    });
                }
            });
        }

    });
    
};
